(function() {
  "use strict";

  angular.module("mVtasWebApp").controller("VentaController", VentaController);

  VentaController.$inject = [
    "$scope",
    "$filter",
    "$state",
    "Venta",
	"VentaFecha",
    "ParseLinks",
    "AlertService"
  ];

  function VentaController(
    $scope,
    $filter,
    $state,
    Venta,
	VentaFecha,
    ParseLinks,
    AlertService
  ) {
    var vm = this;
    vm.transition = transition;
    vm.fromDate = null;
    vm.toDate = null;
	vm.onChangeDate = onChangeDate;
    vm.previousMonth = previousMonth;
    vm.today = today;
	vm.totalizado= 0.00;
	
	vm.toDate=JSON.parse( sessionStorage.getItem( 'fechahasta'), dateReviver );
	vm.fromDate=JSON.parse( sessionStorage.getItem( 'fechadesde'), dateReviver );
	if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
		vm.today();	
	}
	if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
		vm.previousMonth();
	}
	//
	vm.onChangeDate();
	//
    $scope.today = function() {
      $scope.dt = new Date();
    };
    $scope.today();

    $scope.clear = function() {
      $scope.dt = null;
    };

    $scope.inlineOptions = {
      customClass: getDayClass,
      minDate: new Date(),
      showWeeks: true
    };

    //aca llamaban a disabled para sacar los weekends...
    $scope.dateOptions = {
      formatYear: "yy",
      maxDate: new Date(2040, 12, 31),
      minDate: new Date(2018, 8, 1),
      startingDay: 1
    };

    // Disable weekend selection (no lo usamos!)
    function disabled(data) {
      var date = data.date,
        mode = data.mode;
      return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
    }

    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
        ? null
        : new Date();
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };

    $scope.toggleMin();

    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };

    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };

    $scope.setDate = function(year, month, day) {
      $scope.dt = new Date(year, month, day);
    };

    $scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
    $scope.format = $scope.formats[0];
    $scope.altInputFormats = ["M!/d!/yyyy"];

    $scope.popup1 = {   opened: false  };

    $scope.popup2 = {   opened: false  };

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var afterTomorrow = new Date();
    afterTomorrow.setDate(tomorrow.getDate() + 1);
    $scope.events = [
      {
        date: tomorrow,
        status: "full"
      },
      {
        date: afterTomorrow,
        status: "partially"
      }
    ];

    function getDayClass(data) {
      var date = data.date,
        mode = data.mode;
      if (mode === "day") {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

        for (var i = 0; i < $scope.events.length; i++) {
          var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

          if (dayToCheck === currentDay) {
            return $scope.events[i].status;
          }
        }
      }
      return "";
    }

    
    function onChangeDate() {
      var dateFormat = "yyyy-MM-dd";
      var fromDate = $filter("date")(vm.fromDate, dateFormat);
      var toDate = $filter("date")(vm.toDate, dateFormat);

      if (fromDate > toDate) {
        AlertService.error(
          "Fecha Hasta debe ser mayor o igual que Fecha Desde"
        );
        return false;
      }
	  
	  sessionStorage.setItem('fechadesde', JSON.stringify(new Date(vm.fromDate)));
	  sessionStorage.setItem('fechahasta', JSON.stringify(new Date(vm.toDate)));

	   console.log('from ' + fromDate);
	   console.log('to ' + toDate);
	  
      //aca llama al service.js y de ahi al WS backend
      VentaFecha.query(
        { fromDate: fromDate, toDate: toDate },
        function(result) {
			vm.ventas = result;
			vm.totalizado=0;
			var maxl=vm.ventas.length;
			for (var i = 0; i < maxl; i++) { 
			  var vta = vm.ventas[i];
			  vm.totalizado += (vta.ventasmonto-vta.ncreditomonto);
			}
        }
      );
	  
    }

    function transition() {
      $state.transitionTo($state.$current, {
      });
    }

    // Date picker configuration
    function today() {
      // Today + 1 day - needed if the current day must be included
      var today = new Date();
      vm.toDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      ); //+1 seria manana
    }

    function previousMonth() {
      var fromDate = new Date();
      if (fromDate.getMonth() === 0) {
        fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
      } else {
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
      }
      vm.fromDate = fromDate;
    }
	
	//exportacion a Excel/CSV
	var mystyle = {
		  sheetid: 'Ventas',
		  headers:true, 
		  caption: {
			  title:'Ventas',
			  style:'font-size: 50px; color:blue;' 
			},
			style:'font-size:30px',
			column: {style:{Font:{Bold:"1"}}},
			rows: {1:{style:{Font:{Color:"#FF0077"}}}},
			cells: {1:{1:{
				style: {Font:{Color:"#00FFFF"}}
			}}}
	};

	alasql.fn.mydateformat = function(dateStr) {
        var date = new Date(dateStr);
        return date.toLocaleDateString();
        };
	var dateFormat = "dd-MM-yyyy";
    var fechadesde = $filter("date")(vm.fromDate, dateFormat);
    var fechahasta = $filter("date")(vm.toDate, dateFormat);
	var nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
	vm.exportDataExcel = function () {
		alasql('SELECT mydateformat(fecha) as fecha, cantcomercios, cantpv, ventasmonto, totalefectivo, totaltarjeta, ventastickets, ventasitems,ventasmonto/ventastickets as ticketpromedio, ncreditomonto, ncreditotickets, ncreditoitems INTO XLSX("VentaPeriodo_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.ventas]);   
		};
	vm.exportDataCSV = function () {
		alasql('SELECT mydateformat(fecha) as fecha, cantcomercios, cantpv, ventasmonto, totalefectivo, totaltarjeta, ventastickets, ventasitems,ventasmonto/ventastickets as ticketpromedio, ncreditomonto, ncreditotickets, ncreditoitems  INTO CSV("VentaPeriodo_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.ventas]);   		
		};	
		
	//para storage de Date's
	function dateReviver( key, value ) {
		if ( isSerializedDate( value ) ) {
			return( new Date( value ) );
		}
		// If it's not a date-string, we want to return the value as-is. If we fail to return
		// a value, it will be omitted from the resultant data structure.
		return( value );
	}


	// I determine if the given value is a string that matches the serialized-date pattern.
	function isSerializedDate( value ) {
		// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
		var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
		return( isString( value ) && datePattern.test( value ) );
	}


	// I determine if the given value is a String.
	function isString( value ) {
		return( {}.toString.call( value ) === "[object String]" );
	}
  }
})();



 